import React from 'react'

export default function PercentOffResetFormStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .wrapper {
          display: flex;
          flex-direction: column;
          justify-content: stretch;
          height: 98%;
          box-sizing: border-box;
        }

        /****** Products List Container *******/
        .products-list-container {
          flex: 1;
          box-sizing: border-box;
          padding: 3px;
          border: solid 0.5px grey;
          overflow: auto;
        }

        .table-container {
          font-size: 1rem;
          margin-bottom: 5px;
          padding: 2px;
        }
        .table-container:last-child { margin-bottom: 0; }

        .products-list-table {
          border-top: solid 1px black;
          width: 100%;
          box-sizing: border-box;
          border-spacing: 0;
        }
        .products-list-table td { padding: 2px; }
        .products-list-table td:nth-child(1) { width: 2%; }
        .products-list-table td:nth-child(2) { width: 68%; }
        .products-list-table td:nth-child(3) { width: 30%; }

        .products-list-table tr:hover {
          background-color: rgba(22, 22, 205, 0.05);
        }

        /****** Action Button List Container *******/
        .action-button-container {
          margin-top: 10px;
          display: flex;
          justify-content: flex-end;
        }
      `}
      </style>
    </React.Fragment>
  )
}
